import React from "react";

import "./ShoppingCartExpired.css";
import "./ShoppingCart.css";
import { useShoppingCart } from "../context/ShoppingCartContext";
import { CartItemRow } from "./CartItemRow";
import { useAppSelector } from "../../../store/hooks";
import { getPageLocaleUrl } from "../utilities/helpers";
import usePageLanguage from "../hooks/usePageLanguage";
import Modal from "react-bootstrap/Modal";
import "../Checkout/Checkout.css";
import { cartLineKey } from "../utilities/cartIdentity";
import { buildCartDisplaySections } from "../utilities/cartDisplay";

export default function ShoppingCartExpired() {
  const {
    cartItems,
    clearData,
    showCartExpire,
    setShowCartExpire,
    syncOrder,
  } = useShoppingCart();
  const locale = usePageLanguage();

  const [show, setShow] = React.useState(false);

  // Sync local show state with context showCartExpire (never show empty cart)
  React.useEffect(() => {
    if (showCartExpire && cartItems.length === 0) {
      setShow(false);
      setShowCartExpire(false);
      return;
    }
    setShow(showCartExpire && cartItems.length > 0);
  }, [showCartExpire, cartItems.length, setShowCartExpire]);

  const pages = useAppSelector((state) => state.builder.pages.list);
  const languages = useAppSelector(
    (state) => state.builder.languageSettings.activeLanguages
  );
  const checkoutPage = pages.find(
    (page) => page.pageType === "checkout" && page.languageCode === locale
  );
  var checkoutHref = checkoutPage
    ? getPageLocaleUrl(checkoutPage, languages)
    : "/et/checkout";

  if (checkoutHref.substring(0, 1) !== "/") {
    checkoutHref = "/" + checkoutHref;
  }

  const cartDisplaySections = buildCartDisplaySections(cartItems, locale);

  const languageTranslations = {
    et: {
      cartTitle: `SINU OST JÄI POOLELI`,

      cartDescription: `Näib, et jätsite mõned tooted ostukorvi ja ei viinud tellimust lõpuni. Kui soovite selle tellimusega jätkata, siis palun klikkige allpool olevale nupule. Kui te ei soovi eelneva ostuga jätkata, siis võite selle akna sulgeda.`,

      completeOrder: "SOOVIN JÄTKATA",
    },
    en: {
      cartTitle: `YOUR ORDER IS WAITING CONFIRMATION`,

      cartDescription: `It seems that you have left some products to shopping cart and have not completed the order. If you would like to continue the previous order then please click the button below. If you do not wish to continue then you may close this notification.`,

      completeOrder: "I WILL CONTINUE",
    },
  };

  return (
    <div className="shoppingCartExpired" id="shoppingCartExpiredContainer">
      <Modal
        disableRestoreFocus
        show={show && cartItems.length > 0}
        onHide={() => {
          setShow(false);
          setShowCartExpire(false);
          clearData();
        }}
        dialogClassName="modal-700"
        contentClassName="shop-controlled-border-radius"
      >
        {" "}
        <Modal.Header
          closeButton
          style={{
            background: "#f9f9f9",
            borderTopLeftRadius: "var(--shop-border-radius)",
            borderTopRightRadius: "var(--shop-border-radius)",
          }}
        >
          <Modal.Title>
            <span className="fw-bold">
              {languageTranslations[locale]?.cartTitle}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-2 links-green mb-4">
            {languageTranslations[locale]?.cartDescription}
          </div>

          <div className="shoppingCartExpiredContentItems cart-line-items-live">
            {cartDisplaySections.map((section) => (
              <React.Fragment key={section.key}>
                {(section.label || section.showGroupRow) && (
                  <div className="cartEventGroupRow">{section.label}</div>
                )}
                {section.items.map((item) => (
                  <CartItemRow
                    key={cartLineKey(item)}
                    {...item}
                    deleteHidden={true}
                  />
                ))}
              </React.Fragment>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="">
          <a
            href={checkoutHref}
            onClick={async (e) => {
              e.preventDefault();
              // Close the modal immediately so it doesn't "double show" during navigation.
              setShow(false);
              setShowCartExpire(false);
              // Ensure backend renewal happens (and timers are refreshed) before moving to checkout.
              const orderResult = await syncOrder();
              if (!orderResult.ok) {
                return;
              }
              window.location.href = checkoutHref;
            }}
            style={{
              color: "#fff",
              fontWeight: "600",
            }}
            className="btn  w-100 shop-controlled-border-radius shop-controlled-color"
          >
            {languageTranslations[locale]?.completeOrder}
          </a>
        </Modal.Footer>
      </Modal>

      {/* <div className="shoppingCartExpired" id="shoppingCartExpiredContainer">
        <div className="shoppingCartExpiredContent">
          <div
            className="shoppingCartCloseButton"
            onClick={() => {
              const shoppingCartExpiredContainer = document.getElementById(
                "shoppingCartExpiredContainer"
              );

              if (shoppingCartExpiredContainer) {
                shoppingCartExpiredContainer.style.display = "none";
              }

              clearData();
            }}
          >
            <div className="shoppingCartCloseButtonIcon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                  fill="#000"
                />
              </svg>
            </div>
          </div>

          <div className="shoppingCartExpiredContentHeader">
            <span
              className="shoppingCartExpiredContentTitle"
              style={{ textAlign: "left" }}
            >
              {languageTranslations[locale].cartTitle}
            </span>
          </div>

          <div className="shoppingCartExpiredContentContainer">
            <span className="shoppingCartExpiredContentText">
              {languageTranslations[locale].cartDescription}
            </span>

            <a
              href={checkoutHref}
              className="btn btn-primary"
              style={{ width: "fit-content" }}
              onClick={() => {
                const shoppingCartExpiredContainer = document.getElementById(
                  "shoppingCartExpiredContainer"
                );

                if (shoppingCartExpiredContainer) {
                  shoppingCartExpiredContainer.style.display = "none";
                }

                setCartExpireDate();
              }}
            >
              {languageTranslations[locale].completeOrder}
            </a>
          </div>

       

          <div className="shoppingCartExpiredContentItems">
            {cartItems.map((item) => (
              <CartItemRow
                key={cartLineKey(item)}
                {...item}
              />
            ))}
          </div>
        </div>
      </div> */}
    </div>
  );
}